import { formatDateRelative } from "simplydo/core/dates";
import { Icon } from "simplydo/react/ui";

import RowComponent from "components/lib/RowComponent";

import type { HomePoll } from "./types";

type HomePollsProps = { polls: HomePoll[] };
const HomePolls = ({ polls }: HomePollsProps) => {
  if (!polls?.length) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title>Polls</RowComponent.Title>
      </RowComponent.Fill>
      {polls.map((poll, index) => (
        <RowComponent.Cell
          index={index}
          key={poll._id}
          as={"a"}
          href={`/polls/${poll._id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name="bolt" size="big" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: 5,
              marginRight: 5,
              position: "relative",
              top: -1,
            }}
          >
            <RowComponent.Title style={{ color: "#5d5d5d" }} block>
              {poll.name}
            </RowComponent.Title>
            {poll?.hasResponded && (
              <span style={{ color: "green" }}>
                <Icon name="check circle" />
                Completed
              </span>
            )}
            {poll?.deadline && (
              <span style={{ color: "orange" }}>
                <Icon name="time" />
                Closes {formatDateRelative(poll.deadline, { addSuffix: true })}
              </span>
            )}
          </div>
        </RowComponent.Cell>
      ))}
    </RowComponent>
  );
};

export default HomePolls;
